import type { ISitePowerPositionForm } from '@/types/eos/forms'
import type { EOSTableRowUpdates, EOSTableMonthlySummary } from '@/types/eos/Table'
import axios from 'axios'

/**
 * Gets updates from the live-updates endpoint.
 *
 * @param siteId a valid site ID.
 * @returns {Promise<EOSTableRowUpdates>} live updates as an object.
 */
export const getLiveUpdates = async (siteId: string): Promise<EOSTableRowUpdates> => {
  const response = await axios.get<EOSTableRowUpdates>(import.meta.env.VITE_APP_DASHBOARD_UPDATES_ENDPOINT, {
    params: { site: siteId },
  })
  return response.data
}

interface TableMonthlySummaryParams {
  site: string
  month: number
  year: number
  timezone: string
}

export const getTableMonthlySummary = async (options: TableMonthlySummaryParams): Promise<EOSTableMonthlySummary> => {
  const res = await axios.get<EOSTableMonthlySummary>(import.meta.env.VITE_APP_DASHBOARD_MONTHLY_SUMMARY_ENDPOINT, {
    params: options,
  })

  return res.data
}

export const updateSitePowerPosition = async (siteID: string, form: ISitePowerPositionForm) => {
  const res = await axios.put(`${import.meta.env.VITE_APP_SITES_ENDPOINT}/${siteID}/power-positions`, form)
  return res.data
}
